import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 16a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M12 16v-11","key":"svg-1"}],["path",{"d":"M8 3q 2 2 7 2","key":"svg-2"}]]

/**
 * IconUnicycle
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdW5pY3ljbGUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTcgMTZhNSA1IDAgMSAwIDEwIDBhNSA1IDAgMSAwIC0xMCAwIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNnYtMTEiIC8+CiAgPHBhdGggZD0iTTggM3EgMiAyIDcgMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/unicycle
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUnicycle = createReactComponent('outline', 'unicycle', 'Unicycle', __iconNode);

export default IconUnicycle;